import { ReactNode } from 'react';

const ContentWrapper = (props: {children: ReactNode, className?: string}) => <div className={'container ' + (props.className ?? '')}>{props.children}</div>

export default ContentWrapper